import React from 'react'
import styles from '../Proj5Folder/Proj5.module.css'
import ayesh from '../../Images/ayesh.mp4'
import ayesh1 from '../../Images/ayesh1.jpeg'
import ayesh2 from '../../Images/ayesh2.jpeg'
import ayesh3 from '../../Images/ayesh3.jpeg'
import ayesh4 from '../../Images/ayesh4.jpeg'
import ayesh5 from '../../Images/ayesh5.jpeg'
import ayesh6 from '../../Images/ayesh6.jpeg'
import ayesh7 from '../../Images/ayesh7.jpeg'
import ayesh8 from '../../Images/ayesh8.jpeg'
import ayesh10 from '../../Images/ayesh10.jpeg'
import ayesh11 from '../../Images/ayesh11.jpeg'











export default function Ayesh() {
  return (

    <>
        <div className="container my-5 py-5 ">
          <div className="row align-items-center">
            <div className="col-md-6">
                <h3 className={`${styles.color} my-3`}> Ayesh Hospital in 10th of ramadan  ​</h3>
                <p> Project description: Hospital Building    </p>
                <p>Type of contract: Architecture And Cevil Deign </p>
                <p>Type of works : Architecture And Cevil Deign</p>
            </div>
            <div className="col-md-6 text-center">
               <video
                        controls
                        preload="none"
                        // poster={poster}
                        width="100%"
                        playsInline
                        >
         <source src={ayesh} type="video/mp4" />
      
      </video>

            </div>   
          </div> 


         <div className="row my-5 pb-5">
          <div className="col-md-4 my-1 text-center">
               <img src={ayesh1} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
            <div className="col-md-4 my-2 text-center">
               <img src={ayesh2} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
            <div className="col-md-4 my-2 text-center">
               <img src={ayesh3} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
            <div className="col-md-4 my-2 text-center">
               <img src={ayesh4} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
            <div className="col-md-4 my-2 text-center">
               <img src={ayesh5} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
            <div className="col-md-4 my-2 text-center">
               <img src={ayesh6} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
               <div className="col-md-4 my-2 text-center">
               <img src={ayesh7} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
               <div className="col-md-4 my-2 text-center">
               <img src={ayesh8} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>

               <div className="col-md-4 my-2 text-center">
               <img src={ayesh10} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
               <div className="col-md-4 my-2 text-center">
               <img src={ayesh11} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
        
          
          </div>

        </div>

    </>
  )
}
